/**
 * RequirePruebasEnvironment — Route guard que solo permite acceso si el
 * ambiente activo del tenant es "Pruebas" (00). Usado para /auto-pruebas
 * para evitar que un contador en Producción ejecute pruebas mínimas MH
 * o eventos de invalidación/contingencia "de prueba" que en Producción
 * serían reales.
 *
 * Si el ambiente es Producción (01):
 * - redirige al dashboard
 * - muestra un toast amigable
 *
 * El backend también valida (assert_pruebas_environment), así que aunque
 * un usuario malicioso fuerce la URL, el server rechaza con 403.
 */
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAmbiente } from "../context/AmbienteContext";

export default function RequirePruebasEnvironment({ children }) {
  const { ambiente, label } = useAmbiente();

  // Mientras carga el contexto, no redirigir
  if (ambiente === undefined || ambiente === null) return null;

  if (ambiente !== "00") {
    return <RedirectWithToast label={label} />;
  }
  return children;
}

function RedirectWithToast({ label }) {
  useEffect(() => {
    toast.warning(
      `Auto-pruebas MH solo está disponible en ambiente de Pruebas. Estás en ${label || "Producción"}.`,
      { duration: 6000 }
    );
  }, [label]);
  return <Navigate to="/dashboard" replace />;
}

